import { render, staticRenderFns } from "./NsSearchbar.vue?vue&type=template&id=0be7dc38&scoped=true&"
import script from "./NsSearchbar.vue?vue&type=script&lang=js&"
export * from "./NsSearchbar.vue?vue&type=script&lang=js&"
import style0 from "./NsSearchbar.vue?vue&type=style&index=0&id=0be7dc38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../packages/aem/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be7dc38",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/webcomponents-ui - release-finish/src/main/content/webcomponents/js/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0be7dc38')) {
      api.createRecord('0be7dc38', component.options)
    } else {
      api.reload('0be7dc38', component.options)
    }
    module.hot.accept("./NsSearchbar.vue?vue&type=template&id=0be7dc38&scoped=true&", function () {
      api.rerender('0be7dc38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/@nuskin/app-components/components/NsSearchbar.vue"
export default component.exports